import React from 'react';
import './Fait_procedure.css';

const FaitsProcedures = ({ decisionData }) => {
    if (!decisionData) return null;

    return (
        <div id="faits_procedures" className="content-section">
            {decisionData?.faits_procedures ? (
                <p className="content-text">{decisionData?.faits_procedures}</p>
            ) : (
                <p className="no-content-text">Aucune information disponible sur les faits et procédures.</p>
            )}
        </div>
    );
};

export default FaitsProcedures;